import { KeyOutlined } from "@ant-design/icons";
import { Space, Tag, Tooltip } from "antd";

interface ISchemaFieldTitleProps {
    name: string;
    tags?: IDataTag[];
    orientation?: "vertical" | "horizontal";
    tagSummary?: boolean;
    isPrimaryKey?: boolean;
}

export default function SchemaFieldTitle({ name, tags, orientation = "horizontal", tagSummary = true, isPrimaryKey = false }: ISchemaFieldTitleProps) {
    return (
        <>
            {tags && tags.length > 0 ? (
                orientation === "vertical" ? (
                    <Space orientation="vertical">
                        {tagSummary ? (
                            <Space className="tags-summary">
                                <Tag>{tags[0].tagName}</Tag>
                                {tags.length > 1 ? (
                                    <Tooltip
                                        title={tags
                                            .slice(1)
                                            .map((tag) => tag.tagName)
                                            .join(", ")}
                                    >
                                        <Tag>...</Tag>
                                    </Tooltip>
                                ) : (
                                    <></>
                                )}
                            </Space>
                        ) : (
                            tags.map((tag, index) => <Tag key={tag.tagId}>{tag.tagName}</Tag>)
                        )}
                        <Space size={4}>
                            <p style={{ margin: 0 }}>{name}</p>
                            {isPrimaryKey && (
                                <Tooltip title="Primary Key">
                                    <KeyOutlined style={{ color: "#faad14" }} />
                                </Tooltip>
                            )}
                        </Space>
                    </Space>
                ) : (
                    <Space>
                        <Space size={4}>
                            <p style={{ margin: 0 }}>{name}</p>
                            {isPrimaryKey && (
                                <Tooltip title="Primary Key">
                                    <KeyOutlined style={{ color: "#faad14" }} />
                                </Tooltip>
                            )}
                        </Space>
                        {tagSummary ? (
                            <Space>
                                <Tag>{tags[0].tagName}</Tag>
                                {tags.length > 1 ? (
                                    <Tooltip
                                        title={tags
                                            .slice(1)
                                            .map((tag) => tag.tagName)
                                            .join(", ")}
                                    >
                                        <Tag>...</Tag>
                                    </Tooltip>
                                ) : (
                                    <></>
                                )}
                            </Space>
                        ) : (
                            tags.map((tag, index) => <Tag key={tag.tagId}>{tag.tagName}</Tag>)
                        )}
                    </Space>
                )
            ) : (
                <Space size={4}>
                    <p style={{ margin: 0 }}>{name}</p>
                    {isPrimaryKey && (
                        <Tooltip title="Primary Key">
                            <KeyOutlined style={{ color: "#faad14" }} />
                        </Tooltip>
                    )}
                </Space>
            )}
        </>
    );
}
